import React from "react";
import { Modal } from "@/components/Modal";
import { TranslateIcon } from "@/components/common/icons/TranslateIcon";
import { BulbIcon } from "@/components/common/icons/BulbIcon";

import styles from "./ChatControlModal.module.css";

type Props = {
  isOpen?: boolean;
  onClose: () => void;
  onTranslate?: () => void;
  onSuggestion?: () => void;
  suggestionDisabled?: boolean;
};

export const ChatControlModal: React.FC<Props> = ({
  isOpen = false,
  onClose,
  onTranslate,
  onSuggestion,
  suggestionDisabled,
}) => {
  return (
    <Modal withX className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <h1 className={styles.title}>Outils de discussion</h1>
      <div className={styles.items}>
        {onSuggestion && (
          <button
            className={styles.button}
            disabled={suggestionDisabled}
            onClick={() => {
              onClose();
              onSuggestion();
            }}
          >
            <BulbIcon className={styles.bulbIcon} />
            Suggestions
          </button>
        )}
        {onTranslate && (
          <button
            className={styles.button}
            onClick={() => {
              onClose();
              onTranslate();
            }}
          >
            <TranslateIcon className={styles.translateIcon} />
            Traduire
          </button>
        )}
      </div>
    </Modal>
  );
};
